import { Outlet } from "react-router-dom";

import styles from "./styles.module.css";

const AuthLayout = () => {
  return (
    <div className={styles.container}>
      <div className={styles.mainView}>
        <Outlet />
      </div>
    </div>
  );
};

export default AuthLayout;
